import { Badge } from '@mantine/core';
import { OpportunityType } from '../../../models/opportunity.model';

const TYPE_COLOR: Record<OpportunityType, string> = {
  [OpportunityType.None]: 'materialGray',
  [OpportunityType.FullTime]: 'sopraBlue',
  [OpportunityType.PartTime]: 'sopraGreen',
  [OpportunityType.StretchProject]: 'sopraOrange',
  [OpportunityType.Mentorship]: 'sopraPurple',
  [OpportunityType.JobShadow]: 'materialGray',
};

const TYPE_LABEL: Record<OpportunityType, string> = {
  [OpportunityType.None]: 'Unknown',
  [OpportunityType.FullTime]: 'Full-Time',
  [OpportunityType.PartTime]: 'Part-Time',
  [OpportunityType.StretchProject]: 'Stretch Project',
  [OpportunityType.Mentorship]: 'Mentorship',
  [OpportunityType.JobShadow]: 'Job Shadow',
};

interface Props {
  type: OpportunityType;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export const OpportunityTypeBadge = ({ type, size = 'sm' }: Props) => (
  <Badge color={TYPE_COLOR[type]} size={size} variant="light">
    {TYPE_LABEL[type]}
  </Badge>
);
